<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { RowSlot } from '@shared/ui/other'
import { AppInput } from '@shared/ui/inputs'
import { AppDatePicker } from '@shared/ui/fields'

import { useTutorLegalField } from '../../model/legal/tutor-legal-field.hook'

defineOptions({
  name: 'TutorLegalField',
})

withDefaults(defineProps<{
  label: string
  modelValue: string
  tooltip?: string | null
  state?: 'error' | 'static'
  type?: 'text' | 'date'
  placeholder?: string
  message?: string
  disabled?: boolean
  readonly?: boolean
  maxLength?: number
}>(), {
  tooltip: null,
  state: 'static',
  type: 'text',
  placeholder: '',
  message: undefined,
  disabled: false,
  readonly: false,
  maxLength: undefined,
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const {
  setValue,
} = useTutorLegalField({
  onUpdate: (value: string) => emit('update:modelValue', value),
})
</script>

<template>
  <RowSlot
    :label="label"
    :tooltip="tooltip"
  >
    <AppText
      v-if="readonly"
      name="body1"
    >
      {{ modelValue || '—' }}
    </AppText>
    <AppDatePicker
      v-else-if="type === 'date'"
      :value="modelValue"
      :state="state"
      @change="setValue"
    />
    <AppInput
      v-else
      :model-value="modelValue"
      :state="state"
      :placeholder="placeholder"
      :message="message"
      :disabled="disabled"
      :max-length="maxLength"
      @update:model-value="setValue"
    />
  </RowSlot>
</template>
